module.exports = __webpack_public_path__ + "media/fonts/PPNeueMontreal-BoldItalic-fab7fad1.otf";